// import React from "react";

// export const ActionButton = ({
//   children,
//   onClick,
//   type = "button",
//   variant = "primary",
//   disabled = false,
//   loading = false,
//   className = "",
// }) => {
//   const variants = {
//     primary: "bg-blue-600 text-white hover:bg-blue-700",
//     secondary: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50",
//     success: "bg-green-600 text-white hover:bg-green-700",
//   };

//   return (
//     <button
//       type={type}
//       onClick={onClick}
//       disabled={disabled || loading}
//       className={`
//         px-4 py-2 rounded-lg font-medium text-sm
//         transition-all duration-200
//         disabled:opacity-50 disabled:cursor-not-allowed
//         focus:outline-none focus:ring-2 focus:ring-offset-2
//         ${variants[variant]}
//         ${className}
//       `}
//     >
//       {loading ? (
//         <span className="flex items-center">
//           <svg className="animate-spin -ml-1 mr-2 h-4 w-4" viewBox="0 0 24 24">
//             <circle
//               className="opacity-25"
//               cx="12"
//               cy="12"
//               r="10"
//               stroke="currentColor"
//               strokeWidth="4"
//             />
//             <path
//               className="opacity-75"
//               fill="currentColor"
//               d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//             />
//           </svg>
//           Loading...
//         </span>
//       ) : (
//         children
//       )}
//     </button>
//   );
// };
// ActionButton.jsx - Enhanced version that keeps your existing API
import React from "react";

export const ActionButton = ({
  children,
  onClick,
  type = "button",
  variant = "primary",
  disabled = false,
  loading = false,
  className = "",
  icon: Icon, // NEW: Support for icons
  size = "md", // NEW: Support for different sizes
}) => {
  const variants = {
    primary: "bg-blue-600 text-white hover:bg-blue-700 border-blue-600",
    secondary: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50",
    success: "bg-green-600 text-white hover:bg-green-700 border-green-600",
    danger: "bg-red-600 text-white hover:bg-red-700 border-red-600", // NEW
    purple: "bg-purple-600 text-white hover:bg-purple-700 border-purple-600", // NEW
  };

  const sizes = {
    sm: "px-3 py-2 text-sm",
    md: "px-4 py-2 text-sm", // Your existing size
    lg: "px-6 py-3 text-base", // NEW
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        inline-flex items-center gap-2 font-medium rounded-lg
        transition-all duration-200 shadow-sm hover:shadow-md
        disabled:opacity-50 disabled:cursor-not-allowed
        focus:outline-none focus:ring-2 focus:ring-offset-2
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
    >
      {/* Icon support */}
      {Icon && !loading && (
        <Icon className="w-4 h-4" />
      )}
      
      {/* Loading spinner */}
      {loading ? (
        <>
          <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          Loading...
        </>
      ) : (
        children
      )}
    </button>
  );
};